module.exports = __webpack_public_path__ + "static/media/sidebar_aermel.1ad1747f.jpg";